import { useCityStore } from '@/store/city/city'

import { EcommerceEventName } from '@/types/plugins/yandex-metrika'
import type { CommonProductModification } from '@/types/products'

import { mapEcommerceData } from '@/services/metrics/utils/ecommerce'

/* Комплексная отправка метрики добавления/удаления единиц продукта */
export const useSendMetricsOfProduct = (
  currentProduct?: CommonProductModification | null,
) => {
  const { $metrics } = useNuxtApp()

  const route = useRoute()

  const cityStore = useCityStore()

  const currencyCode = computed(() => cityStore.currencyCode)

  const pushMetrics = (typeEvent: EcommerceEventName, quantity: number) => {
    if (!currentProduct) return

    const ecommerceData = mapEcommerceData(
      currentProduct,
      typeEvent,
      currencyCode.value || '',
      quantity,
    )

    $metrics?.eventAddProduct({ ym: ecommerceData })
    $metrics?.eventSendGoal({ mt: 'Basketcomplete' })

    window.carrotquest?.track('cart_added', {
      name: currentProduct.full_name,
      url: route.path + currentProduct?.slug, // TODO нужен slug в ProductV5Modification
      amount: currentProduct.price,
      img: currentProduct.image,
    })
  }

  return { pushMetrics }
}
